module.exports = __webpack_public_path__ + "img/bg-widget-feedback.be21ce2e.svg";